import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class ZebaNotifyMe extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
    this.bindInteractions();
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  bindInteractions() {
    const trigger = this.querySelector('[data-zeba-notify-trigger]');
    const form = this.querySelector('[data-zeba-notify-form]');
    const success = this.querySelector('[data-zeba-notify-success]');
    const error = this.querySelector('[data-zeba-notify-error]');

    trigger?.addEventListener('click', () => {
      trigger.hidden = true;
      if (form) form.hidden = false;
      form?.querySelector('input[type="email"]')?.focus();
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitForm(form, success, error);
    });
  }

  async submitForm(form, success, error) {
    const emailInput = form.querySelector('input[type="email"]');
    const bodyField = form.querySelector('[data-zeba-notify-body-prefix]');
    if (bodyField && emailInput && !bodyField.dataset.filled) {
      bodyField.value = `${bodyField.value}${emailInput.value}`;
      bodyField.dataset.filled = 'true';
    }

    const submitBtn = form.querySelector('.zeba-notify-me__submit');
    if (submitBtn) submitBtn.disabled = true;
    if (error) error.hidden = true;

    try {
      const formData = new FormData(form);
      const response = await fetch('/contact', { method: 'POST', body: formData });
      if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
      form.hidden = true;
      if (success) success.hidden = false;
    } catch (err) {
      console.warn('[zeba-notify-me] Submission failed:', err);
      if (error) error.hidden = false;
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const newNotify = detail.html.querySelector('zeba-notify-me');
        if (!newNotify) return;
        morph(this, newNotify, { childrenOnly: true });
        this.hidden = newNotify.hasAttribute('hidden');
        this.bindInteractions();
      })
      .catch((err) => {
        if (err?.name !== 'AbortError') console.warn('[zeba-notify-me] Event promise rejected:', err);
      });
  };
}

if (!customElements.get('zeba-notify-me')) {
  customElements.define('zeba-notify-me', ZebaNotifyMe);
}
